function LoadingComponent({ ...props }) {
  return null;
  // return (
  //   <div className="div-loadable ">
  //     <div className="div-fas-spinner">
  //       <i className="fas fa-spinner fa-pulse fa-3x"></i>
  //     </div>
  //   </div>
  // );
}

export default LoadingComponent;
